<!-- 产品解决方案／群星金融N+1供应链金融产品 -->
<template>
  <div id="platform">
    <header v-if="roletype === 'core'">
        <div class="cover">
            <h1>
                <span>平台产品</span>
                <strong @click="coreProduct = 'operator'" :class="coreProduct === 'operator' ? 'choose' : ''">核心端操作平台</strong>
                <strong @click="coreProduct = 'tool'" :class="coreProduct === 'tool' ? 'choose' : ''">智能诊断工具</strong>
                <strong @click="coreProduct = 'product'" :class="coreProduct === 'product' ? 'choose' : ''">数据风控产品</strong>
            </h1>
            <template v-if="coreProduct === 'operator'">
                <div class="left">
                    <div class="introduce">
                        <h2>用户类型</h2>
                        <h3>核心企业</h3>
                    </div>
                    <div class="introduce">
                        <h2>注册方式</h2>
                        <h3>采用后台企业预设、用户通过手机号注册登录</h3>
                    </div>
                    <div class="introduce">
                        <h2>产品亮点</h2>
                        <h3>业务批量上线；轻松统筹上下游；资金流向一目了然</h3>
                    </div>
                </div>
                <div class="right-area">
                    <el-carousel :interval="5000" arrow="always" :loop='false' :autoplay='false' indicator-position="outside" height='420px'>
                        <el-carousel-item><img src="/imgs/portal/products/hx1_1@2x.png" alt="img"></el-carousel-item>
                        <el-carousel-item><img src="/imgs/portal/products/hx1_2@2x.png" alt="img"></el-carousel-item>
                    </el-carousel>
                </div>
            </template>
            <template v-else-if="coreProduct === 'tool'">
                <div class="left">
                    <div class="introduce">
                        <h2>用户类型</h2>
                        <h3>核心企业</h3>
                    </div>
                    <div class="introduce">
                        <h2>注册方式</h2>
                        <h3>采用后台企业预设、用户通过手机号注册登录</h3>
                    </div>
                    <div class="introduce">
                        <h2>产品亮点</h2>
                        <h3>快速了解核心企业基本信息；供应链融资需求诊断；自动化生成推荐方案；方案效果智能可视化；定制化群星方案报告</h3>
                    </div>
                </div>
                <div class="right-area">
                    <el-carousel :interval="5000" arrow="always" :loop='false' :autoplay='false' indicator-position="outside" height='420px'>
                        <el-carousel-item><img src="/imgs/portal/products/hx2_1@2x.png" alt="img"></el-carousel-item>
                        <el-carousel-item><img src="/imgs/portal/products/hx2_2@2x.png" alt="img"></el-carousel-item>
                        <el-carousel-item><img src="/imgs/portal/products/hx2_3@2x.png" alt="img"></el-carousel-item>
                    </el-carousel>
                </div>
            </template>
            <template v-else-if="coreProduct === 'product'">
                <div class="left">
                    <div class="introduce">
                        <h2>用户类型</h2>
                        <h3>核心企业</h3>
                    </div>
                    <div class="introduce">
                        <h2>注册方式</h2>
                        <h3>采用后台企业预设、用户通过手机号注册登录</h3>
                    </div>
                    <div class="introduce">
                        <h2>产品亮点</h2>
                        <h3>助缩短项目分析周期；加速资产分析批量化；成为Woodpecker和群星平台的接力站</h3>
                    </div>
                </div>
                <div class="right-area">
                    <el-carousel :interval="5000" arrow="always" :loop='false' :autoplay='false' indicator-position="outside" height='420px'>
                        <el-carousel-item><img src="/imgs/portal/products/hx3_1@2x.png" alt="img"></el-carousel-item>
                        <el-carousel-item><img src="/imgs/portal/products/hx3_2@2x.png" alt="img"></el-carousel-item>
                        <el-carousel-item><img src="/imgs/portal/products/hx3_3@2x.png" alt="img"></el-carousel-item>
                    </el-carousel>
                </div>
            </template>
        </div>
    </header>
    <header v-else-if="roletype === 'institution'">
        <div class="cover">
            <h1>
                <span style="margin-right:650px;">平台产品</span>
                <strong @click="institutionProduct = 'products'" :class="institutionProduct === 'products' ? 'choose' : ''">数据风控产品</strong>
                <strong @click="institutionProduct = 'platform'" :class="institutionProduct === 'platform' ? 'choose' : ''">机构端操作平台</strong>
            </h1>
            <template v-if="institutionProduct === 'products'">
                <div class="left">
                    <div class="introduce">
                        <h2>用户类型</h2>
                        <h3>金融机构</h3>
                    </div>
                    <div class="introduce">
                        <h2>注册方式</h2>
                        <h3>采用手机号注册</h3>
                    </div>
                    <div class="introduce">
                        <h2>产品亮点</h2>
                        <h3>充分利用机器学习；动态追踪，实时观测风险，预防欺诈；精准区分出风险的高低</h3>
                    </div>
                </div>
                <div class="right-area">
                    <el-carousel :interval="5000" arrow="always" :loop='false' :autoplay='false' indicator-position="outside" height='420px'>
                        <el-carousel-item><img src="/imgs/portal/products/jg1_1@2x.png" alt="img"></el-carousel-item>
                        <el-carousel-item><img src="/imgs/portal/products/jg1_2@2x.png" alt="img" style="width: 288px;margin-top: 30px;"></el-carousel-item>
                    </el-carousel>
                </div>
            </template>
            <template v-else-if="institutionProduct === 'platform'">
                <div class="left">
                    <div class="introduce">
                        <h2>用户类型</h2>
                        <h3>金融机构</h3>
                    </div>
                    <div class="introduce">
                        <h2>注册方式</h2>
                        <h3>采用手机号注册</h3>
                    </div>
                    <div class="introduce">
                        <h2>产品亮点</h2>
                        <h3>风险实时监控；风险可视化；操作便捷</h3>
                    </div>
                </div>
                <div class="right-area">
                    <el-carousel :interval="5000" arrow="always" :loop='false' :autoplay='false' indicator-position="outside" height='420px'>
                        <el-carousel-item><img src="/imgs/portal/products/jg2_1@2x.png" alt="img"></el-carousel-item>
                        <el-carousel-item><img src="/imgs/portal/products/jg2_2@2x.png" alt="img"></el-carousel-item>
                        <el-carousel-item><img src="/imgs/portal/products/jg2_3@2x.png" alt="img"></el-carousel-item>
                    </el-carousel>
                </div>
            </template>
        </div>
    </header>
    <header v-else-if="roletype === 'chain'">
        <div class="cover">
            <h1>
                <span style="margin-right:770px;">平台产品</span>
                <strong>链属端操作平台</strong>
            </h1>
            <div class="left">
                <div class="introduce">
                    <h2>用户类型</h2>
                    <h3>供应商／经销商</h3>
                </div>
                <div class="introduce">
                    <h2>注册方式</h2>
                    <h3>采用手机号注册</h3>
                </div>
                <div class="introduce">
                    <h2>产品亮点</h2>
                    <h3>多终端覆盖；账户体系，款票货一致；操作便捷，一键收款</h3>
                </div>
            </div>
            <div class="right-area">
                <el-carousel :interval="5000" arrow="always" :loop='false' :autoplay='false' indicator-position="outside" height='420px'>
                    <el-carousel-item><img src="/imgs/portal/products/ls1_1@2x.png" alt="img"></el-carousel-item>
                    <el-carousel-item><img src="/imgs/portal/products/ls1_2@2x.png" alt="img"></el-carousel-item>
                    <el-carousel-item><img src="/imgs/portal/products/ls1_2@2x.png" alt="img"></el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </header>
    <section>
        <div class="cover">
            <h1>立即体验</h1>
            <portal-form :from='"product"' :roleType='roletype'></portal-form>
            <h3>此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。<br>有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的<a href='/pdf/tips.pdf' download="隐私声明">隐私声明</a>。</h3>
        </div>
    </section>
    <portal-footer :page='"download-home"' :roleType='roletype'></portal-footer>
  </div>
</template>

<script>
import Footer from '../Footer'
import ModelFormVue from '../ModelForm.vue'

export default {
  created () {
    this.roletype = this.$route.query.role
  },
  components: {
    'portal-footer': Footer,
    'portal-form': ModelFormVue
  },
  methods: {
    upImg (type) {
      console.log(type)
    },
    downImg (type) {
      console.log(type)
    }
  },
  data () {
    return {
      loop: false,
      roletype: 'core', // 企业角色
      institutionProduct: 'products', // 机构产品tab切换
      coreProduct: 'operator' // 核心产品tab切换
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~@/assets/css/utils';
@import '../../css/theme-config';

#platform {
  margin-top: 96px;
  background: #f2f2f2;
  .cover {
    width: 1000px;
    margin: 0 auto;
  }
  header {
    height: 600px;
    background: url(/imgs/portal/products/platform_bg2@2x.png) center center
      no-repeat;
    background-size: cover;
    h1 {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #ffffff;
      letter-spacing: 0.5px;
      line-height: 24px;
      font-weight: normal;
      margin: 0;
      border-bottom: 1px solid rgba(#ffffff, 0.2);
      padding: 24px 0 6px;
      box-sizing: border-box;
      span {
        display: inline-block;
        margin-right: 540px;
      }
      strong {
        display: inline-block;
        font-weight: normal;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        opacity: 0.6;
        letter-spacing: 0.5px;
        line-height: 14px;
        margin: 0 0 5px 20px;
        cursor: pointer;
        transition: all 0.2s;
        &.choose {
          opacity: 1;
          &:hover{
            color: #ffffff;
          }
        }
        &:hover{
          color: #66BBFF;
        }
      }
    }
    .left {
      color: #ffffff;
      width: 330px;
      display: inline-block;
      vertical-align: top;
      padding-top: 60px;
      margin-right: 85px;
      .introduce {
        padding-left: 90px;
        background: url(/imgs/portal/products/user@2x.png) left top no-repeat;
        background-size: 70px 70px;
        margin: 0 0 53px;
        min-height: 70px;
      }
      .introduce:nth-child(2) {
        background-image: url(/imgs/portal/products/login@2x.png);
      }
      .introduce:nth-child(3) {
        background-image: url(/imgs/portal/products/product@2x.png);
      }
      h2 {
        font-family: PingFangSC-Semibold;
        font-size: 24px;
        color: #ffffff;
        letter-spacing: 0.5px;
        line-height: 24px;
        font-weight: normal;
        margin: 0;
        padding-top: 6px;
      }
      h3 {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0.5px;
        text-align: justify;
        line-height: 22px;
        font-weight: normal;
        margin: 12px 0 0;
      }
    }
    .right-area {
      width: 580px;
      height: 420px;
      display: inline-block;
      vertical-align: top;
      position: absolute;
      box-sizing: border-box;
      margin-top: 46px;
      text-align: center;
      img{
        width: 575px;
      }
    }
  }
  section {
    height: 600px;
    background: #fff;
    text-align: center;
    padding-top: 70px;
    box-sizing: border-box;
    h1 {
      font-weight: 600;
      margin: 0 0 32px;
      font-family: PingFangSC-Semibold;
      font-size: 40px;
      color: #111111;
      letter-spacing: 1.05px;
      text-align: center;
      line-height: 40px;
    }
    h3 {
      margin: 12px 0 0;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #a8acb9;
      letter-spacing: 0.18px;
      text-align: center;
      line-height: 18px;
      font-weight: normal;
      a {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #1f5dea;
        letter-spacing: 0.18px;
        text-align: center;
        line-height: 18px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Platform.vue?3d47147a